// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/effect-cards";
import "swiper/css/effect-fade";
import "swiper/css/effect-flip";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "../../components/SwiperCarousel/styles.css";

// import required modules
import {
  // EffectFade,
  Navigation,
  Pagination,
  // EffectCoverflow,
  EffectFlip,
} from "swiper";
import { FC } from "react";

interface CarouselData {
  imgSrc: string;
  id: string;
}

interface SwiperCarouselProps {
  carouselData: CarouselData[];
}

const SwiperCarousel: FC<SwiperCarouselProps> = ({ carouselData }) => {
  const renderCarousel = () => {
    if (!carouselData) return null;
    return carouselData?.map((item, index) => {
      return (
        <SwiperSlide>
          <img src={item.imgSrc} alt={`${item.imgSrc}_${item.id}`}></img>
        </SwiperSlide>
      );
    });
  };

  return (
    <Swiper
      effect={"flip"}
      grabCursor={true}
      pagination={true}
      navigation={true}
      modules={[EffectFlip, Pagination, Navigation]}
      className="mySwiper"
    >
      {renderCarousel()}
    </Swiper>
  );
};

export default SwiperCarousel;
